import type React from "react";

import { cn } from "@ui/lib/utils";

export const AudioListItem = ({
  children,
  className,
  ref,
  hoverEffects = true,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & { hoverEffects?: boolean; ref?: React.Ref<HTMLDivElement> }) => {
  return (
    <div
      className={cn(
        "flex min-h-[72px] cursor-pointer items-center gap-20 border-b px-8 py-16 last:border-b-0 md:px-16",
        hoverEffects && "hover:bg-dark",
        className,
      )}
      ref={ref}
      role='region'
      {...props}
    >
      {children}
    </div>
  );
};

export const AudioListItemContent = ({
  children,
  className,
  ref,
  endAligned = true,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & { endAligned?: boolean; ref?: React.Ref<HTMLDivElement> }) => {
  return (
    <div className={cn("flex-1 space-y-12 lg:space-y-20", className)} ref={ref} {...props}>
      <div className={cn("flex grow items-center gap-20 xl:gap-64 xl:px-8", endAligned && "justify-between")}>
        {children}
      </div>
    </div>
  );
};

export const AudioListItemHeader = ({
  children,
  className,
  ref,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & { ref?: React.Ref<HTMLDivElement> }) => {
  return (
    <div className={cn("flex flex-col md:flex-1", className)} ref={ref} {...props}>
      {children}
    </div>
  );
};
